import React from 'react'

function LushAbout() {
    return (

        <section id="lush-about" className="">
            <div className="container pt-5">
                <div className='row mb-5 p-2'>

                    <div className='row'>
                        <iframe width="100%" height="600rem"
                            title="XQVNmgdYRUQ"
                            src="https://www.youtube.com/embed/xbTUqUh9-Fc?autoplay=1&controls=1&loop=0&mute=0&rel=0&start=0">
                        </iframe>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-lg-8 mb-3'>
                            <h5 className='text-start m-0 p-0 text-primary'>About LUSH Residences:</h5>
                            <p className='text-start mb-0 pb-0'>
                                <small>
                                    1. Location. Location. Location. The 3 most important consideration when buying property.
                                    LUSH Residences is in a very prime location accessible to major commercial and business
                                    centers thru a covered walkway so it’s convenient to walk rain or shine. No need to take transportation
                                    as everywhere in Makati CBD is within walking distance as this is just very near Ayala Avenue.
                                    Walking is good for the health, too, so buying into this property will be a very good decision.
                                </small>
                            </p>
                            <p className='text-start mb-0'>
                                <small>
                                    2. Low density building. This is a one (1)- building development with only several residential floors that start on the 7th floor. Only 19 floors of residential units. Parking is on the 2nd floor up to the 6th floor.
                                </small>
                            </p>
                            <p className='text-start mb-0'>
                                <small>
                                    3. Unique design. This unique design allows to have more prime units with panoramic views.
                                </small>
                            </p>
                            <p className='text-start mb-0'>
                                <small>
                                    4. Green wall feature. LUSH Residences is envisioned and planned to be surrounded by greenery that is truly living up to its name. With this lush vegetation around the building, its amenity level will have better air flow what with the fresh oxygen coming out from the plants while toxic fumes are filtered by such plants. Now that is healthier.
                                </small>
                            </p>
                            <p className='text-start mb-0'>
                                <small>
                                    5. Public art facility. This will be open to the public for art enthusiasts which is good for the soul and spirit.
                                </small>
                            </p>
                        </div>
                        <div className='col-lg-4'>
                            <h5 className='text-start m-0 p-0 text-primary'>Pre-selling now, Your Future Passive Income</h5>
                            <p className='text-start'>
                                <small>
                                    Pre-selling with much room for capital appreciation upon turn-over,
                                    Lush Residences units are being offered at affordable prices and terms.
                                    Once Ready for Occupancy (RFO) this can be the source of passive income
                                    through rental whether short-term like AirBnB or long term like yearly contracts.
                                    Worry-free and hassle-free ownership as we have licensed Real Estate Professionals
                                    to handle your requirements of finding clients for you. We can even handle Property
                                    Management for Buyers who are abroad on in the provinces or those who might need our services.
                                </small>
                            </p>
                        </div>

                    </div>

                    

                </div>
            </div>
        </section>

    )
}

export default LushAbout
